<template>
  <div class="d-flex align-center justify-center">
    <v-progress-circular
      :size="90"
      :width="10"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</template>
<script>
export default {
  name: "Loader",
};
</script>
